import { render } from "./RewardsPage.vue?vue&type=template&id=bd9a41f6&scoped=true"
import script from "./RewardsPage.vue?vue&type=script&lang=js"
export * from "./RewardsPage.vue?vue&type=script&lang=js"

import "./RewardsPage.vue?vue&type=style&index=0&id=bd9a41f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd9a41f6"]])

export default __exports__